import { useSettingsStore } from '@/stores/settingsStore';
import { translations, TranslationKey } from '@/utils/translations';

export function useTranslation() {
  const language = useSettingsStore((state) => state.language);

  const t = (key: TranslationKey): string => {
    return translations[language][key] || key;
  };

  const formatCurrency = (amount: number): string => {
    return `${amount.toLocaleString()} ${t('egp')}`;
  };

  const formatDate = (date: string | Date): string => {
    const d = new Date(date);
    return d.toLocaleDateString(language === 'ar' ? 'ar-EG' : 'en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  const formatDateTime = (date: string | Date): string => {
    const d = new Date(date);
    return d.toLocaleDateString(language === 'ar' ? 'ar-EG' : 'en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return { t, formatCurrency, formatDate, formatDateTime, language };
}
